"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  tooltip: {
    background: theme.tooltip.background,
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: theme.tooltip.borderRadius,
    position: 'absolute',
    top: 0,
    left: -100000,
    opacity: 0,
    zIndex: 100,
    transition: theme.transitionArr([['opacity', 200, 0], ['transform', 400, 0]]),
    maxWidth: 360
  },
  bottomSide: {
    transform: 'translate3d(0,-4px,0)'
  },
  topSide: {
    transform: 'translate3d(0,4px,0)'
  },
  rightSide: {
    transform: 'translate3d(4px,0,0)'
  },
  leftSide: {
    transform: 'translate3d(-4px,0,0)'
  },
  active: {
    opacity: 1,
    transform: 'translate3d(0,0,0)'
  },
  text: {
    color: theme.tooltip.textColor,
    textAlign: 'justify'
  },
  arrow: {
    background: theme.tooltip.background,
    borderRadius: theme.tooltip.borderRadiusArrow,
    transform: 'rotate(45deg)',
    position: 'absolute'
  },
  bottom: {
    top: -3,
    left: 'calc(50% - 3px)'
  },
  top: {
    bottom: -3,
    left: 'calc(50% - 3px)'
  },
  right: {
    left: -3
  },
  left: {
    right: -3
  },
  medium: {
    padding: 8,
    '& $text': {
      fontSize: theme.tooltip.textSizeMedium
    },
    '& $arrow': {
      height: 6,
      width: 6
    }
  },
  large: {
    padding: '8px 12px',
    '& $text': {
      fontSize: theme.tooltip.textSizeLarge
    },
    '& $arrow': {
      height: 12,
      width: 12
    }
  }
});

exports.default = _default;